module.exports = __webpack_public_path__ + "img/q_heart.f5ac0767.jpg";